import Footer from 'components/nav/Footer'
import Header from 'components/nav/Header'
import { ReactFC } from 'common/types/ReactFC'
import { useWithoutNav } from 'project/isWithoutNav'
import { Tenant } from 'common/tenant'

export type PageContainerProps = {
  hideFooterCard?: boolean
  transparentHeader?: boolean
  hideFooter?: boolean
  tenant?: Tenant
}
export const PageContainer: ReactFC<PageContainerProps> = ({
  tenant = Tenant.UK,
  children,
  hideFooter,
  hideFooterCard,
  transparentHeader,
}) => {
  const hideNav = useWithoutNav()
  return (
    <>
      {!hideNav && <Header tenant={tenant} transparentHeader={transparentHeader} />}
      {children}
      {!hideNav && !hideFooter && (
        <Footer tenant={tenant} hideFooterCard={hideFooterCard} />
      )}
    </>
  )
}

PageContainer.displayName = 'PageContainer'
export default PageContainer
